var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-min-sida';
                    var viewUrl = 'gfx/sprite.svg#view-icon-min-sida';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };